import React from 'react';
import PaymentMethodDetailItem from './components/PaymentMethodDetailItem';
const PaymentMethodDetails = ({ items }) => (React.createElement("div", { className: "payment-method-details" }, items.map((item, idx) => (React.createElement(PaymentMethodDetailItem, { key: `payment-method-details-item-${idx + 1}`, ...item })))));
export default PaymentMethodDetails;
